import { makeStyles } from "@material-ui/core/styles";

const useCommentsPanelStyles = makeStyles((theme) => ({
  shell: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: 0,
    width: "100%",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "10px",
    overflow: "hidden",
    boxSizing: "border-box",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
  },
  tabBar: {
    display: "flex",
    flexShrink: 0,
    backgroundColor: theme.palette.primary.main,
    borderBottom: `1px solid ${theme.palette.secondary.light}`,
  },
  tabButton: {
    flex: 1,
    textTransform: "none",
    fontSize: "13px",
    fontWeight: 500,
    borderRadius: 0,
    padding: "10px 8px",
    minWidth: 0,
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.text.tertiary,
  },
  tabButtonActive: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.primary,
  },
  toolbar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "10px 12px",
    flexShrink: 0,
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  },
  commentCount: {
    fontSize: "13px",
    color: theme.palette.text.tertiary,
  },
  publishButton: {
    textTransform: "none",
    fontSize: "12px",
    color: theme.palette.text.primary,
    border: `1px solid #6C65D9`,
    borderRadius: "8px",
    padding: "4px 10px",
    minWidth: 0,
  },
  commentsList: {
    flex: 1,
    overflowY: "auto",
    padding: "8px",
    position: "relative",
  },
  groupHeader: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "12px",
    marginTop: "8px",
    "&:first-child": {
      marginTop: "0",
    },
  },
  groupDivider: {
    flex: 1,
    height: "1px",
    backgroundColor: `#6C65D9 !important`,
  },
  groupName: {
    flexShrink: 0,
    fontSize: "14px",
    maxWidth: "65%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    color: "#ECECEC",
  },
  commentItem: {
    padding: "8px 0",
    borderBottom: `1px solid #3F404A`,
    boxSizing: "border-box",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  commentHead: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  draftBadge: {
    border: "1px solid #EFB13A4D",
    background: "#EFB13A2E",
    color: "#F9F9F9",
    padding: "2px 8px",
    borderRadius: "5px",
    fontSize: "12px",
  },
  commentAuthor: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    minWidth: 0,
  },
  avatar: {
    width: "28px",
    height: "28px",
    fontSize: "12px",
    fontWeight: 500,
    backgroundColor: theme.palette.secondary.main,
    color: "black",
  },
  authorName: {
    fontSize: "14px",
    color: "#B1B5C9",
  },
  commentTime: {
    fontSize: "12px",
    color: "#B1B5C9",
    flexShrink: 0,
  },
  commentBody: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  timestamp: {
    color: "#4ADE80",
    fontSize: "13px",
    fontWeight: 500,
  },
  seekableTimestamp: {
    color: "#62FFC0",
    fontSize: "14px",
    cursor: "pointer",
    width: "fit-content",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  commentText: {
    fontSize: "14px",
    color: "#ECECEC",
    lineHeight: 1,
  },
  draftCommentInput: {
    width: "100%",
    minHeight: "60px",
    backgroundColor: theme.palette.secondary.light,
    border: `1px solid ${theme.palette.secondary.main}`,
    borderRadius: "8px",
    outline: "none",
    resize: "vertical",
    padding: "8px 10px",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    color: theme.palette.text.primary,
    boxSizing: "border-box",
    "&::placeholder": {
      color: theme.palette.text.tertiary,
      opacity: 1,
    },
  },
  commentFooter: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  repliesLabel: {
    fontSize: "14px",
    color: "#606479",
  },
  commentFooterLeft: {
    display: "flex",
    alignItems: "center",
  },
  showHideRepliesButton: {
    textTransform: "none",
    fontSize: "13px",
    color: theme.palette.secondary.main,
    padding: 0,
    minWidth: 0,
  },
  repliesList: {
    marginLeft: "36px",
    marginTop: "8px",
    display: "flex",
    flexDirection: "column",
  },
  replyItem: {
    borderLeft: `2px solid ${theme.palette.secondary.light}`,
    paddingLeft: "5px",
  },
  replyHead: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "4px",
    flexWrap: "wrap",
  },
  replyBody: {
    marginLeft: "24px",
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  draftActions: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginLeft: "auto",
  },
  draftActionButtonOutlined: {
    minWidth: "24px",
    width: "32px",
    height: "24px",
    padding: "3px 8px",
    border: `1px solid #6C65D9`,
    borderRadius: "5px",
    color: "white",
  },
  draftActionButtonFilled: {
    minWidth: "24px",
    width: "32px",
    height: "24px",
    padding: "3px 8px",
    borderRadius: "5px",
    color: "#F9F9F9 !important",
    backgroundColor: `#6C65D9 !important`,
  },
  inputSection: {
    flexShrink: 0,
    padding: "8px 10px 10px",
    borderTop: `1px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.secondary.light,
    boxSizing: "border-box",
  },
  inputToolbar: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "8px",
    flexWrap: "wrap",
  },
  timecodeBox: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "4px",
    padding: "4px 8px",
    fontSize: "12px",
    color: theme.palette.text.primary,
  },
  tagVersion: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    fontSize: "12px",
    color: theme.palette.text.tertiary,
  },
  draftButton: {
    textTransform: "none",
    fontSize: "11px",
    color: "#CE7606",
    backgroundColor: "rgba(206, 118, 6, 0.15)",
    borderRadius: "4px",
    padding: "4px 8px",
    minWidth: 0,
    marginLeft: "auto",
  },
  inputRow: {
    display: "flex",
    alignItems: "flex-end",
    gap: "8px",
  },
  replyCard: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "8px",
    padding: "8px 10px",
    marginBottom: "8px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "8px",
    boxSizing: "border-box",
  },
  replyCardContent: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    minWidth: 0,
    flex: 1,
  },
  replyCardText: {
    fontSize: "13px",
    color: theme.palette.text.primary,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  textInput: {
    flex: 1,
    minHeight: "44px",
    backgroundColor: theme.palette.primary.main,
    borderRadius: "8px",
    boxSizing: "border-box",
    overflow: "hidden",
  },
  postEditorInput: {
    minHeight: "44px",
    maxHeight: "80px",
    overflowY: "auto",
    padding: "6px 10px",
    "& .public-DraftEditorPlaceholder-root": {
      color: theme.palette.text.tertiary,
    },
    "& .public-DraftEditor-content": {
      minHeight: "32px",
      color: theme.palette.text.primary,
      fontSize: "13px",
      fontFamily: "Poppins, sans-serif",
    },
  },
  commentInput: {
    width: "100%",
    minHeight: "44px",
    maxHeight: "80px",
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
    resize: "none",
    padding: "10px 12px",
    fontSize: "13px",
    fontFamily: "Poppins, sans-serif",
    color: theme.palette.text.primary,
    boxSizing: "border-box",
    "&::placeholder": {
      color: theme.palette.text.tertiary,
      opacity: 1,
    },
  },
  sendButton: {
    backgroundColor: theme.palette.secondary.main,
    borderRadius: "10px",
    minWidth: "44px",
    width: "44px",
    height: "44px",
    padding: 0,
    flexShrink: 0,
    color: theme.palette.text.primary,
  },
  versionCommentsBody: {
    flex: 1,
    minHeight: 0,
    overflow: "hidden",
  },
  versionCommentInput: {
    flexShrink: 0,
    marginTop: "10px",
    height: "90px",
    padding: "4px 10px 10px",
    boxSizing: "border-box",
    backgroundColor: theme.palette.secondary.light,
  },
}));

export default useCommentsPanelStyles;
